/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const searchLinkWithDescriptionStyles = xcss({
	width: 'fill',
	padding: 'space.100',
	display: 'grid',
	columnGap: 'space.100',
	gridTemplateColumns: 'auto 1fr',
	gridTemplateAreas: `
    "icon title"
    "icon description"
  `,
	alignItems: 'center',
	height: '50px',
	borderRadius: 'radius.large',
});

const iconSkeleton = xcss({
	gridArea: 'icon',
	backgroundColor: 'color.background.neutral',
	width: '24px',
	height: '24px',
	borderRadius: 'radius.xsmall',
});

const titleSkeleton = xcss({
	gridArea: 'title',
	backgroundColor: 'color.background.neutral',
	width: '260px',
	height: '14px',
	borderRadius: 'radius.xsmall',
});

const descriptionSkeleton = xcss({
	gridArea: 'description',
	backgroundColor: 'color.background.neutral',
	width: '150px',
	height: '10px',
	borderRadius: 'radius.xsmall',
});

export const SearchLinkSkeleton = (): JSX.Element => {
	return (
		<Box xcss={searchLinkWithDescriptionStyles}>
			<Box xcss={iconSkeleton} />
			<Box xcss={titleSkeleton} />
			<Box xcss={descriptionSkeleton} />
		</Box>
	);
};
